import {
  getToneClasses,
  type SemanticTone,
} from "@/components/shared/tone-styles"
import { cn } from "@/lib/utils"

const severityToneMap: Record<"high" | "medium" | "low", SemanticTone> = {
  high: "danger",
  medium: "warning",
  low: "success",
}

export function MissingCountPill({
  missingCount,
  severity,
}: {
  missingCount: number
  severity: "high" | "medium" | "low"
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-1 text-[0.68rem] font-semibold",
        getToneClasses(severityToneMap[severity], "subtle"),
      )}
    >
      {missingCount} missing
    </span>
  )
}
